var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 7.33396L3.33398 10.334C3.33398 11.9908 4.67715 13.334 6.33402 13.3339L9.18398 13.3339M6.80065 2.66732L10.7006 2.66732C11.4186 2.66732 12.0006 3.26427 12.0006 4.00064L12.0007 9.77838C12.0007 10.5148 11.4186 11.1117 10.7007 11.1117L6.80065 11.1117C6.08268 11.1117 5.50065 10.5148 5.50065 9.77838L5.50065 4.00064C5.50065 3.26427 6.08268 2.66732 6.80065 2.66732Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.bf74a04bc345e715dc028396072fe8ed.svg";
export { ForwardRef as ReactComponent };